import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { ArticleCatalog } from './article-models';
import {
  AutoFormControlPopupTreeNode,
  convertArrayToTree
} from '@muchencute/mrrs-types';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleCatalogService {

  tree = new BehaviorSubject<AutoFormControlPopupTreeNode[]>([]);

  array = new BehaviorSubject<ArticleCatalog[]>([]);

  private _baseURL: string;

  static _calculateArticleCount(tree: AutoFormControlPopupTreeNode[]): AutoFormControlPopupTreeNode[] {

    const _getChildrenArticleCount = (node: AutoFormControlPopupTreeNode) => {
      let count = 0;
      node.children.forEach(c => {
        if (!_.isEmpty(c.children)) {
          c.data.articleCount = (c.data.articleCount || 0) + _getChildrenArticleCount(c);
        }
        count += c.data.articleCount || 0;
      });
      return count;
    };

    tree.forEach(n => {
      n.data.articleCount = (n.data.articleCount || 0) + _getChildrenArticleCount(n);
    });
    return tree;
  }

  constructor(private httpClient: HttpClient,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/articlecatalog`;
    this.getCatalogs().subscribe();
  }

  newCatalog(articleCatalog: ArticleCatalog): Observable<ArticleCatalog> {
    articleCatalog.parent = articleCatalog.parent || 0;
    return this.httpClient.post<ArticleCatalog>(`${this._baseURL}`, articleCatalog);
  }

  updateCatalog(articleCatalog: ArticleCatalog): Observable<any> {
    return this.httpClient.put(`${this._baseURL}/${articleCatalog.id}`, articleCatalog);
  }

  removeCatalog(id: number): Observable<any> {
    return this.httpClient.delete(`${this._baseURL}/${id}`);
  }

  getCatalogs(): Observable<any> {
    return this.httpClient.get(`${this._baseURL}s`).pipe(
      tap((items: any[]) => this.array.next(items)),
      map((items: any[]) => ArticleCatalogService._calculateArticleCount(convertArrayToTree(items))),
      tap(tree => this.tree.next(tree))
    );
  }

  mergeCatalogs(id: number, toId: number): Observable<any> {
    return this.httpClient.put<any>(`${this._baseURL}/${id}/tocatalog/${toId}`, {}).pipe(
      map((items: any[]) => convertArrayToTree(items)),
    );
  }
}
